import { FormArray, FormBuilder, FormGroup } from '@angular/forms';
import { IncomeTable } from './knowledge-test.models';

export function getIncomeTableFormGroup(
  fb: FormBuilder
): FormArray<FormGroup<IncomeTable>> {
  return fb.nonNullable.array([
    fb.nonNullable.group({
      netIncome: fb.nonNullable.control(0),
      regularIncome: fb.nonNullable.control(false),
    }),
  ]);
}

export function addFormGroup(
  formArray: FormArray<FormGroup<IncomeTable>>,
  fb: FormBuilder
): FormArray<FormGroup<IncomeTable>> {
  formArray.push(
    new FormGroup({
      netIncome: fb.nonNullable.control(0),
      regularIncome: fb.nonNullable.control(false),
    })
  );
  return formArray;
}
